import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// Las fuentes de la FIP servidas por la app y no por Google: cuando llegue la
// PWA (etapa 6) entran al precache y andan sin senal.
import '@fontsource/bebas-neue/latin-400.css';
import '@fontsource/titillium-web/latin-400.css';
import '@fontsource/titillium-web/latin-600.css';
import '@fontsource/titillium-web/latin-700.css';
import './index.css';

const raiz = document.getElementById('root');
if (!raiz) throw new Error('Falta <div id="root"> en index.html');

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
